export default __webpack_public_path__ + "static/media/avatar.22c31152.png";